const _prefix = '@dashboard/';

export default {
  GET_NUMBER_OF_VIEWS_REQUEST: _prefix + 'GET_NUMBER_OF_VIEWS_REQUEST',
  GET_NUMBER_OF_VIEWS_SUCCESS: _prefix + 'GET_NUMBER_OF_VIEWS_SUCCESS',

  GET_VIEWS_PER_SECTION_REQUEST: _prefix + 'GET_VIEW_PER_SECTION_REQUEST',
  GET_VIEWS_PER_SECTION_SUCCESS: _prefix + 'GET_VIEW_PER_SECTION_SUCCESS',

  GET_NUMBER_OF_UNIQUE_VISITOR_REQUEST: _prefix + 'GET_NUMBER_OF_UNIQUE_VISITOR_REQUEST',
  GET_NUMBER_OF_UNIQUE_VISITOR_SUCCESS: _prefix + 'GET_NUMBER_OF_UNIQUE_VISITOR_SUCCESS',

  GET_TOP_50_SEARCH_TERMS_REQUEST: _prefix + 'GET_TOP_50_SEARCH_TERM_REQUEST',
  GET_TOP_50_SEARCH_TERMS_SUCCESS: _prefix + 'GET_TOP_50_SEARCH_TERM_SUCCESS',

  UPDATE_VIEW_REQUEST: _prefix + 'UPDATE_VIEW_REQUEST',
  UPDATE_SECTION_VIEW_REQUEST: _prefix + 'UPDATE_SECTION_VIEW_REQUEST',
  UPDATE_UNIQUE_VISITOR_REQUEST: _prefix + 'UPDATE_UNIQUE_VISITOR_REQUEST'
};
